<template>
  <TopGradientBlockLayout ref="pie_charts" style="height: auto;">
    <div class="flex items-center mb-15">
      <div class="text-xl font-bold text-text leading-tight">{{ $t('structureTitle') }}</div>
      <div class="text-md text-text-ternary font-bold ml-auto flex items-center" v-if="main_chart_selected_point">
        {{ $t('fromDate') }} {{ humanized_date(selected_point_date_range(filters.group_by).start) }}
        {{ $t('toDate') }} {{ humanized_date(selected_point_date_range(filters.group_by).end) }}
        <div class="bg-red rounded cursor-pointer hover:bg-red-hover
                   transition duration-200 text-white text-md  px-2  ml-2" @click="setChartPoint(null)">
          <font-awesome-icon icon="times"/>
        </div>
      </div>
      <div class="text-md text-text-ternary font-bold ml-auto" v-else>
        {{ $t('fromDate') }} {{ humanized_date(filters.date.start) }} {{ $t('toDate') }}
        {{ humanized_date(filters.date.end) }}
      </div>
    </div>
    <div class="pb-12 mb-12 border-b border-border grid grid-cols-9 col-gap-16" v-if="expense_groups.data.length > 1">
      <div class="relative col-span-5">
        <ChartLoadingOverlay v-if="chart_data_in_point.dirty || chart_data.date_dirty"/>
        <CustomPieChart chart-id="chart-group"
                        :chart-data="doughnutChartStructureGroupData"
                        :selected-slice="structure_group_selected_point"
                        :styles="{width:'100%',height:'200px'}"
                        @click="selectChartStructureGroup($event)"/>
      </div>
      <div class="col-span-4">
        <div class="text-md font-bold text-text leading-tight mb-6">{{ $t('expenseGroupTitle') }}</div>
        <ChartLegendDisplay :legend="chartGroupLegend"/>
      </div>
    </div>
    <div class="grid grid-cols-9 col-gap-16">
      <div class="relative col-span-5">
        <ChartLoadingOverlay v-if="chart_data_in_point.dirty || chart_data.date_dirty"/>
        <CustomPieChart chart-id="chart-category"
                        :chart-data="doughnutChartStructureCategoryData"
                        :styles="{width:'100%',height:'200px'}"/>
      </div>
      <div class="col-span-4">
        <div class="text-md font-bold text-text leading-tight mb-6">{{ $t('expenseCategoryTitle') }}</div>
        <ChartLegendDisplay :legend="chartCategoryLegend"/>
      </div>
    </div>


  </TopGradientBlockLayout>
</template>

<script>
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import ChartLoadingOverlay from "@/components/cabinet/Money/Reports/charts/ChartLoadingOverlay";
import CustomPieChart from "@/components/cabinet/Money/Reports/charts/CustomPieChart";
import {mapGetters, mapMutations, mapState} from "vuex";
import ChartLegendDisplay from "@/components/cabinet/Money/Reports/charts/ChartLegendDisplay";

export default {
  name: "ReportExpenseStructureChart",
  components: {ChartLegendDisplay, CustomPieChart, ChartLoadingOverlay, TopGradientBlockLayout},
  computed: {
    ...mapState('space/expenses', ['expense_groups']),
    ...mapState('reports/report_filters', ['filters']),
    ...mapState('reports/report_expense', ['chart_data', 'chart_data_in_point', 'structure_group_selected_point', 'main_chart_selected_point']),
    ...mapGetters('reports/report_expense', ['selected_point_date_range', 'doughnutChartStructureGroupData', 'doughnutChartStructureCategoryData']),
    chartGroupLegend() {
      return this.doughnutChartStructureGroupData.labels.map((item, i) => {
        return {
          bg: this.doughnutChartStructureGroupData.datasets[0].backgroundColor[i],
          label: item
        }
      })
    },
    chartCategoryLegend() {
      return this.doughnutChartStructureCategoryData.labels.map((item, i) => {
        return {
          bg: this.doughnutChartStructureCategoryData.datasets[0].backgroundColor[i],
          label: item
        }
      })
    },
  },
  methods: {
    ...mapMutations('reports/report_expense', ['setChartPoint', 'selectChartStructureGroup']),
    humanized_date(val) {
      return this.$moment(val).format('DD.MM.YYYY')
    },
  },
  i18n: {
    messages: {
      en: {
        structureTitle: 'Expenses structure',
        expenseGroupTitle: 'Expense groups',
        expenseCategoryTitle: 'Expense categories',
        fromDate: 'from',
        toDate: 'to'
      },
      ru: {
        structureTitle: 'Структура расходов',
        expenseGroupTitle: 'Группы расходов',
        expenseCategoryTitle: 'Категории расходов',
        fromDate: 'с',
        toDate: 'по'
      }
    }
  }
}
</script>